/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import * as api from '../../api';
import * as types from '../action.types';

import { executeRules } from './rule.actions';
import { addMessage } from './message.actions';
import { resetState } from './status.actions';

const fetchSessionsRequest = () => ({
  type: types.FETCH_SESSIONS_REQUEST,
});

const fetchSessionsSuccess = data => ({
  type: types.FETCH_SESSIONS_SUCCESS,
  payload: data,
});

const fetchSessionsError = () => ({
  type: types.FETCH_SESSIONS_ERROR,
});

const fetchSessionRequest = () => ({
  type: types.FETCH_SESSION_REQUEST,
});

const fetchSessionSuccess = data => ({
  type: types.FETCH_SESSION_SUCCESS,
  payload: data,
});

const fetchSessionError = () => ({
  type: types.FETCH_SESSION_ERROR,
});

const addFileRequest = () => ({
  type: types.ADD_FILE_REQUEST,
});

const addFileError = () => ({
  type: types.ADD_FILE_ERROR,
});

const deleteSessionRequest = () => ({
  type: types.DELETE_SESSION_REQUEST,
});

const deleteSessionSuccess = sessionId => ({
  type: types.DELETE_SESSION_SUCCESS,
  payload: sessionId,
});

const deleteSessionError = () => ({
  type: types.DELETE_SESSION_ERROR,
});

const deleteFileFromSessionRequest = () => ({
  type: types.DELETE_SESSION_FILE_REQUEST,
});

const deleteFileFromSessionSuccess = (sessionId, fileId) => ({
  type: types.DELETE_SESSION_FILE_SUCCESS,
  payload: {
    sessionId,
    fileId,
  },
});

const deleteFileFromSessionError = () => ({
  type: types.DELETE_SESSION_FILE_ERROR,
});

const fetchSessionFilesRequest = () => ({
  type: types.FETCH_SESSION_FILES_REQUEST,
});

const fetchSessionFilesSuccess = (sessionId, files) => ({
  type: types.FETCH_SESSION_FILES_SUCCESS,
  payload: {
    sessionId,
    files,
  },
});

const fetchSessionFilesError = () => ({
  type: types.FETCH_SESSION_FILES_ERROR,
});

const saveSessionRequest = () => ({
  type: types.SAVE_SESSION_REQUEST,
});

const saveSessionSuccess = () => ({
  type: types.SAVE_SESSION_SUCCESS,
});

const saveSessionError = () => ({
  type: types.SAVE_SESSION_ERROR,
});

const updateSessionNameRequest = () => ({
  type: types.UPDATE_SESSION_NAME_REQUEST,
});

const updateSessionNameSuccess = (sessionId, name) => ({
  type: types.UPDATE_SESSION_NAME_SUCCESS,
  payload: {
    sessionId,
    name,
  },
});

const updateSessionNameError = () => ({
  type: types.UPDATE_SESSION_NAME_ERROR,
});

const updateSessionHideRequest = () => ({
  type: types.UPDATE_SESSION_HIDE_REQUEST
});

const updateSessionHideSuccess = (sessionId,hide) => ({
  type: types.UPDATE_SESSION_HIDE_SUCCESS,
  payload: {
    sessionId,
    hide
  }
});

const updateSessionHideError = () => ({
  type: types.UPDATE_SESSION_NAME_ERROR
})

const updateFileActiveRequest = () => ({
  type: types.UPDATE_FILE_ACTIVE_REQUEST,
});

const updateFileActiveSuccess = (sessionId, fileId, active) => ({
  type: types.UPDATE_FILE_ACTIVE_SUCCESS,
  payload: {
    sessionId,
    fileId,
    active,
  },
});

const updateFileNameRequest = () => ({
  type: types.UPDATE_FILE_FILENAME_REQUEST,
});
const updateFileNameError = () => ({
  type: types.UPDATE_FILE_FILENAME_ERROR,
});
const updateFileNameSuccess = (sessionId, fileId, filename) => ({
  type: types.UPDATE_FILE_FILENAME_SUCCESS,
  payload: {
    sessionId,
    fileId,
    filename,
  },
});

export const updateRulesApplied = (sessionId, fileId, rulesApplied) => ({
  type: types.UPDATE_FILE_RULES_APPLIED,
  payload: {
    sessionId,
    fileId,
    rulesApplied,
  },
});

export const updateSkippedColumnsHidden = (sessionId, fileId, skippedColumnsHidden) => ({
  type: types.UPDATE_FILE_SKIPPED_COLUMNS_HIDDEN,
  payload: {
    sessionId,
    fileId,
    skippedColumnsHidden,
  },
});

const updateFileActiveError = () => ({
  type: types.UPDATE_FILE_ACTIVE_ERROR,
});

export const updateFileNotesEditorContent = (sessionId, fileId, notesEditorContent) => ({
  type: types.UPDATE_FILE_NOTES_EDITOR_CONTENT,
  payload: {
    sessionId,
    fileId,
    notesEditorContent,
  },
});
export function updateFileRulesApplied(sessionId, fileId, rulesApplied){
  return (dispatch) =>{
    dispatch(updateRulesApplied(sessionId,fileId,rulesApplied))
    dispatch(executeRules(sessionId,fileId))
  }
}
export function updateFileSkippedColumnsHidden(sessionId, fileId, skippedColumnsHidden){
  return (dispatch) =>{
    dispatch(updateSkippedColumnsHidden(sessionId,fileId,skippedColumnsHidden))
    dispatch(executeRules(sessionId,fileId))
  }
}
const updateMoveVirtualFileRequest = () => ({
  type: types.MOVE_VIRTUAL_FILE_REQUEST,
});

const updateMoveVirtualFileSuccess = (sessionId, fileId, amountDown) => ({
  type: types.MOVE_VIRTUAL_FILE_SUCCESS,
  payload: {
    sessionId,
    fileId,
    amountDown
  },
});
const updateMoveVirtualFileError = () => ({
  type: types.MOVE_VIRTUAL_FILE_ERROR,

});
export function addFile(state, sessionId) {
  const uploadState = state;

  return (dispatch) => {
    dispatch(addFileRequest());

    return api.uploadFiles(uploadState, 0, 1, sessionId)
      .then(() => {
        dispatch(fetchSessions());
      }).catch((e) => {
        console.error(e);
        dispatch(addMessage('error', e.message));
        dispatch(addFileError());
      });
  };
}

export function deleteSession(sessionId) {
  return (dispatch) => {
    dispatch(deleteSessionRequest());

    return api.deleteSession(sessionId).then(() => {
      dispatch(deleteSessionSuccess(sessionId));
    }).catch(({ message }) => {
      dispatch(addMessage('error', message));
      dispatch(deleteSessionError());
    });
  };
}

export function deleteFileFromSession(sessionId, fileId) {
  return (dispatch) => {
    dispatch(deleteFileFromSessionRequest());

    return api.deleteFileFromSession(sessionId, fileId).then(() => {
      dispatch(deleteFileFromSessionSuccess(sessionId, fileId));
    }).catch(({ message }) => {
      dispatch(addMessage('error', message));
      dispatch(deleteFileFromSessionError());
    });
  };
}

export function updateSessionName(sessionId, name) {
  return (dispatch) => {
    dispatch(updateSessionNameRequest());

    return api.updateSessionName(sessionId, { name })
      .then(() => {
        dispatch(updateSessionNameSuccess(sessionId, name));
      }).catch(({ message }) => {
        dispatch(addMessage('error', message));
        dispatch(updateSessionNameError());
      });
  };
}

export function updateSessionHide(sessionId,hide) {
  return (dispatch) => {
    dispatch(updateSessionHideRequest());

    return api.hideSession(sessionId,hide)
      .then(() => {
        dispatch(updateSessionHideSuccess(sessionId,hide));
      }).catch(({message}) => {
        dispatch(addMessage('error', message));
        dispatch(updateSessionHideError());
      })
  }
}
export function updateFileActive(sessionId, fileId, active) {
  return (dispatch, getState) => {
    dispatch(updateFileActiveRequest());

    const files = getState().sessions[sessionId].files;
    const file = files[fileId];
    const canDelete = file.virtualFile && !_.some(files, f => f.origin === file.filename);
    return api.updateSessionFileActive(sessionId, fileId, active)
      .then(() => {
        if (canDelete) {
          dispatch(deleteFileFromSessionSuccess(sessionId, fileId));
          dispatch(resetState());
        } else {
          dispatch(updateFileActiveSuccess(sessionId, fileId, active));
        }
      }).catch(({ message }) => {
        dispatch(addMessage('error', message));
        dispatch(updateFileActiveError());
      });
  };
}
export function updateFileName(sessionId, fileId, filename) {
  return (dispatch, getState) => {
    dispatch(updateFileNameRequest());

    const files = getState().sessions[sessionId].files;
    const file = files[fileId];

    return api.updateSessionFileName(sessionId, fileId, filename)
      .then(() => {
        dispatch(updateFileNameSuccess(sessionId, fileId, filename));
      }).catch(({ message }) => {
        dispatch(addMessage('error', message));
        dispatch(updateFileNameError());
      });
  };
}
export function moveVirtualFile(sessionId, fileId, amountDown) {
  return (dispatch) => {
    dispatch((updateMoveVirtualFileRequest()));
    return api.moveVirtualFile(sessionId,fileId,amountDown)
      .then(() => {
        dispatch(updateMoveVirtualFileSuccess(sessionId,fileId, amountDown));
        dispatch(resetState())
      })
  }
}
export function fetchSessions() {
  return (dispatch) => {
    dispatch(fetchSessionsRequest());

    return api.fetchSessions().then((data) => {
      dispatch(fetchSessionsSuccess(data));
    }).catch(({ message }) => {
      dispatch(addMessage('error', message));
      dispatch(fetchSessionsError());
    });
  };
}

export function fetchSessionFiles(sessionId) {
  return async (dispatch) => {
    dispatch(fetchSessionFilesRequest());

    return api.fetchSessionFiles(sessionId).then((data) => {
      dispatch(fetchSessionFilesSuccess(sessionId, data));
    }).catch(({ message }) => {
      dispatch(addMessage('error', message));
      dispatch(fetchSessionFilesError());
    });
  };
}

export function fetchSessionFile(sessionId, fileId, skipRules = false, offset = 0, limit = 50) {
  return (dispatch) => {
    if (!skipRules) dispatch(resetState());
    dispatch(fetchSessionRequest());

    return api.fetchSessionFile(sessionId, fileId, offset, limit)
      .then((data) => {
        dispatch(fetchSessionSuccess(data));
        if (!skipRules) dispatch(executeRules(sessionId, fileId));
      }).catch(({ message }) => {
        dispatch(addMessage('error', message));
        dispatch(fetchSessionError(message));
      });
  };
}

export function saveSession() {
  return (dispatch, getState) => {
    dispatch(saveSessionRequest());
    const { currentSessionId, currentFileId } = getState().status;
    const currentFile = getState().sessions[currentSessionId].files[currentFileId];
    const rules = _.map(getState().rules.rules, rule => ({
      attribute: rule.attribute,
      text: rule.text,
      index: rule.index,
      active: rule.active
    }));
    const data = {
      ...currentFile,
      savedByUser: _.size(getState().metadata) > 0,
      rules,
      metadata: getState().metadata,
      joins: _.values(getState().joins.joins),
      notesEditorContent: getState().sessions[currentSessionId].files[currentFileId].notesEditorContent,
    };
    return api.saveSession(currentSessionId, data)
      .then(() => {
        dispatch(saveSessionSuccess());
      }).catch(({ message }) => {
        dispatch(addMessage('error', message));
        dispatch(saveSessionError());
      });
  };
}
